// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"200128c6","266":"bf40cfa1","269":"cddd397c","375":"c97c5369","728":"2282cfed","768":"8e0af8fc","785":"a75112c2","921":"c6f20016"}[chunkId] + ".chunk.js";
};